import {
  LEGACY_EVENTS,
  NOTIFICATION_TYPES,
  SOCKET_EVENTS,
} from './constants/socketEvents';

function isChatMessageLike(obj) {
  if (!obj || typeof obj !== 'object') return false;
  return Boolean(
    obj.content ||
    obj.msg_id ||
    obj.w_id ||
    obj.text ||
    obj.body ||
    obj.message ||
    obj.message_data
  );
}

export function normalizeInterveneSocketPayload(payload) {
  if (!payload || typeof payload !== 'object') return null;

  if (payload.v === 1 && payload.type) {
    return {
      kind: 'v1',
      type: payload.type,
      eventId: payload.event_id,
      data: payload.data || {},
      meta: payload.meta || {},
      raw: payload,
    };
  }

  const payloadType = String(payload.type || '').trim();

  const isChatMessageEvent =
    payloadType === LEGACY_EVENTS.CHAT_MESSAGES ||
    payloadType === SOCKET_EVENTS.CHAT_MESSAGE ||
    payloadType === 'chat_message' ||
    payloadType === 'chatMessage' ||
    payloadType === 'message' ||
    payloadType === 'new_message';

  if (isChatMessageEvent) {
    const messageData =
      payload.message ||
      payload.message_data ||
      payload.data ||
      (isChatMessageLike(payload) ? payload : {});

    return {
      kind: 'legacy',
      type: SOCKET_EVENTS.CHAT_MESSAGE,
      data: messageData,
      raw: payload,
    };
  }

  if (payloadType === LEGACY_EVENTS.INTERVENE_STATUS) {
    return {
      kind: 'legacy',
      type: SOCKET_EVENTS.SESSION_UPDATED,
      data: payload.message || payload.data || payload,
      raw: payload,
    };
  }

  if (payloadType === LEGACY_EVENTS.CURRENT_USERS) {
    return {
      kind: 'legacy',
      type: SOCKET_EVENTS.PRESENCE_UPDATED,
      data: {
        bot_number: payload.bot_number,
        phone_number: payload.phone_number,
        users: payload.users || [],
      },
      raw: payload,
    };
  }

  if (
    payloadType === LEGACY_EVENTS.STATUS_NOTIFICATION &&
    payload.notification_type === 'message_status_update'
  ) {
    return {
      kind: 'legacy',
      type: SOCKET_EVENTS.MESSAGE_STATUS,
      data: payload.data || {},
      raw: payload,
    };
  }

  if (payloadType === LEGACY_EVENTS.NOTIFICATION) {
    if (payload.notification_type === NOTIFICATION_TYPES.QUEUE_COUNTS) {
      return {
        kind: 'legacy',
        type: SOCKET_EVENTS.COUNTS_UPDATED,
        data: payload.data || {},
        raw: payload,
      };
    }

    const isExplicitUnreadNotification =
      payload.notification_type === NOTIFICATION_TYPES.UNREAD_COUNTS ||
      payload.notification_type === NOTIFICATION_TYPES.CONVERSATION_UNREAD ||
      payload.notification_type === 'conversation_unread';

    if (
      !isExplicitUnreadNotification &&
      (payload.message_data ||
        payload.notification_type === NOTIFICATION_TYPES.NEW_USER_MESSAGE ||
        isChatMessageLike(payload.data))
    ) {
      return {
        kind: 'legacy',
        type: SOCKET_EVENTS.CHAT_MESSAGE,
        data: payload.message_data || payload.data || payload.message || payload,
        raw: payload,
      };
    }

    return {
      kind: 'notification',
      type: payload.notification_type,
      data: payload.data || {},
      raw: payload,
    };
  }

  if (payload.message_data && isChatMessageLike(payload.message_data)) {
    return {
      kind: 'legacy',
      type: SOCKET_EVENTS.CHAT_MESSAGE,
      data: payload.message_data,
      raw: payload,
    };
  }

  if (payload.message) {
    return {
      kind: 'legacy',
      type: SOCKET_EVENTS.CHAT_MESSAGE,
      data: payload.message,
      raw: payload,
    };
  }

  if (isChatMessageLike(payload)) {
    return {
      kind: 'legacy',
      type: SOCKET_EVENTS.CHAT_MESSAGE,
      data: payload,
      raw: payload,
    };
  }

  return null;
}
